import socket from "../socket/socket";

export const resendOrderRequest = async (order) => {
  socket.emit("merchant:sendOrderRequest", order);
};
